import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class LegalBlogIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<g>
					<path d="M1022.3 624.4h.1l-168-366.9 40.7-20.3-15.3-30.5-39.7 19.8-5.4-11.7a17 17 0 00-31 0l-4.8 10.4a219.5 219.5 0 00-92.3-20.4H563.2v-34.1h34.1v-34.2H568l12.3-49a70.4 70.4 0 10-136.6 0l12.3 49h-29.3v34.2h34.1v34.1H317.5c-31.9 0-63.4 7-92.4 20.5l-4.8-10.5a17 17 0 00-31 0l-5.4 11.7-39.7-19.9-15.3 30.6 40.8 20.4L1.6 624.4c-1 2.2-1.6 4.6-1.6 7C0 697.5 53.5 751 119.5 751H290c66 0 119.4-53.5 119.5-119.4 0-2.5-.6-4.9-1.7-7.1L239.3 256.2a185.6 185.6 0 0178.2-17.3h143.3v624.4l-58.3 58.3h-61.2a85.4 85.4 0 00-85.3 85.3 17 17 0 0017 17.1h478a17 17 0 0017-17 85.4 85.4 0 00-85.3-85.4h-61.2l-58.3-58.3V239h143.4c27 0 53.7 6 78.2 17.3L616 624.4c-1 2.2-1.6 4.6-1.6 7 0 66 53.5 119.5 119.5 119.5h170.6c66 0 119.4-53.5 119.5-119.4 0-2.5-.6-4.9-1.7-7.1zM290 716.8H119.5a85.5 85.5 0 01-83.7-68.3h338a85.5 85.5 0 01-83.7 68.3zM366 614.4H43.7l156.7-342c2.9.7 6 .7 8.8 0l156.7 342zM483.4 48.1a37.3 37.3 0 0157.1 0 36 36 0 016.7 31l-14.4 57.4h-41.6l-14.4-57.3a36 36 0 016.6-31.1zM495 204.8v-34.1h34.2v34.1h-34.2zm34.2 34.1v614.4h-34.2V239h34.2zm153.6 716.8c21.7 0 41 13.7 48.2 34.2H293.1a51.3 51.3 0 0148.2-34.2h341.4zm-109.5-34.1H450.8l34.1-34.1h54.2l34.1 34.1zm241.6-649.2c2.8 1 5.9.9 8.6-.3l157 342.3H658l156.7-342zm89.7 444.4H734a85.5 85.5 0 01-83.7-68.3h338a85.5 85.5 0 01-83.7 68.3z"
					/>
				</g>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
